import domReady from '@wordpress/dom-ready';
import SimpleParallax from "simple-parallax-js";

domReady( function () {

    const images = document.querySelectorAll('.parallax-enabled img');
    new SimpleParallax(images, {
        scale: 1.15,
        delay: 0.3,
        overflow: false,
        transition: "cubic-bezier(0,0,0,1)",
    });

});